module.exports = __webpack_public_path__ + "static/img/jiqi-txt6.f9f1fa0.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/page-one/img/jiqi-txt6.png
// module id = afGt
// module chunks = 0